import { Facebook, LinkedIn, Mail, Phone } from '@mui/icons-material'
import { Container } from '@mui/material'
import React from 'react'

interface Props { }

function TopHeader(props: Props) {

    return (
        <div className='topHeader'>
            <Container maxWidth="lg" className='topHeader__inner'>
                <div className='topHeader__group'>
                    <a href="tel:+237690767963"><Phone /><span>(+237) 690 767 963</span></a>
                    <a href="mailto:contact@ibgalphatech.com"><Mail /><span>contact@ibgalphatech.com</span></a>
                </div>
                <div className='topHeader__group'>
                    <button type="button" aria-label="LinkedIn"><LinkedIn /></button>
                    <button type="button" aria-label="Facebook"><Facebook /></button>
                </div>
            </Container>
        </div>
    )
}

export default TopHeader
